import React, { Component } from "react";
import { connect } from "react-redux";
import "react-dates/initialize";
import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import Auto from "../autocomplete/autocomplete";
import { apiUrl } from "../common/constants";
import {
  findKey,
  getRevDate,
  getDateForSrch,
  fetchGet,
  getDaysOfOperation,
  getWeekDayIndex
} from "../../common/common";
import { updateStaticCityList, updateCityList, updateFromCityList, updateAllCityTownFromList, updateFromCityName, updateTourCategoryName, updateTourPackageName } from "../../actions/search-actions";
import store from "../../store";
import { renderImg } from "../common/icons/img";
import { t, STARTING_FROM, GOING_TO, JOURNEY_DATE, RETURN_DATE, SINGLE_LADY, MODIFY, CHO0SE_DATE, OPTIONAL } from "../../translations/Modify";

//const defaultDaysAllowed = [0,1,2,3,4,5,6];
const defaultDaysAllowed = "reset";

class Modify extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLoader: false,
      cityTownFromList: [],
      cityTownId: this.props.search.searchParams.fromCity,
      cityTownName: '',
      newCityTownId:0,

      tourCategoryList: [],
      tourCategoryId: this.props.search.searchParams.tourCategory,
      tourCategoryName: '',

      tourPackageList: [],
      tourPackageId: this.props.search.searchParams.tripRoute,
      tourPackageName: '',

      focused: false,
      retFocused: false,
      fromErr: false,
      toErr: false,
      depErr: false,
      depDate: moment(
        new Date(getRevDate(this.props.search.searchParams.jDate))
      ),
      alerterror: "",
      daysAllowed:defaultDaysAllowed,
    };
  }

  componentDidMount() {
    const that = this;
    this.getCityTownFromList();
  }

  //for from city get data
  getCityTownFromList = () => {

    const that = this;

    if (Object.keys(that.props.search.fromCityList).length > 0) {

      const fromCityList = that.props.search.fromCityList;

      //for show tour category
      that.parseFromCityData(fromCityList);

    } else {

      const url = window.url + apiUrl.getSelectCityTownFrom;

      fetchGet(url)
        .then(function (response) {

          /**const response = "{"Success":true,"ErrorMessage":null,"data":[{"Name":"Bengaluru (Blr)","CityTownID":-32768},{"Name":"Chennai (Chni)","CityTownID":-32720},{"Name":"Dasara Special Tour","CityTownID":17},{"Name":"Dasara Special Trip Mys","CityTownID":15},{"Name":"Ernakulam","CityTownID":-32682},{"Name":"Gulbarga","CityTownID":4},{"Name":"Hospet","CityTownID":-32655},{"Name":"Hubli (Hbli)","CityTownID":-32738},{"Name":"Hyderabad (hydb)","CityTownID":-32739},{"Name":"Kalaburgi","CityTownID":19},{"Name":"Mangaluru (Mlr)","CityTownID":-32767},{"Name":"Mercara","CityTownID":-32664},{"Name":"Mysore(Msr)","CityTownID":-32676},{"Name":"PBD Packages","CityTownID":16},{"Name":"SPECIAL TOUR FOR WOMEN","CityTownID":18},{"Name":"Torangal","CityTownID":7}]}"; */
          const resp = JSON.parse(response);

          if (resp?.Success) {

            const fromCityList = resp.data;
            store.dispatch(updateFromCityList(fromCityList));

            //for show tour category
            that.parseFromCityData(fromCityList);
          }

        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }

  //modify data for from city
  parseFromCityData = (fromCityList) => {

    let that = this;

    let cityTownFromList = [];
    fromCityList && Object.entries(fromCityList).forEach(([index, cityFromObj]) => {
      cityTownFromList.push({ Name: cityFromObj.Name, Key: cityFromObj.Name, ID: cityFromObj.CityTownID });
    });

    const { cityTownId } = that.state;

    //for get object matched with from city id and get city name
    const fromCityObj = Object.values(cityTownFromList).find(el => el.ID == cityTownId);
    const cityTownName = fromCityObj?.Name || '';

    that.setState({ cityTownFromList, cityTownName });

    store.dispatch(updateFromCityName(cityTownName));

    //for load tour category 
    that.getTourCategoryPackage(cityTownId,false);

  }

  getTourCategoryPackage = (cityTownId,showLoader=false) => {

    const that = this;
    /* 
        if (Object.keys(that.props.search.allPrmCityTownIDFromData).length > 0) {
    
          const allPrmCityTownData = that.props.search.allPrmCityTownIDFromData;
    
          //for show tour category
          that.parseTourCategoryData(allPrmCityTownData);
    
          //for show tour package
          that.parseTourPackageData(allPrmCityTownData);
    
        } else { */

    if(showLoader){
      that.setState({ showLoader: true });
    }

    const url = `${window.url + apiUrl.getAllPrmCityTownIDFrom}?CityTownID=${cityTownId}`;

    fetchGet(url)
      .then(function (allPrmCityResponse) {

        const allPrmCityRes = JSON.parse(allPrmCityResponse);

        if (allPrmCityRes?.Success) {

          const allPrmCityTownData = allPrmCityRes.data;
          store.dispatch(updateAllCityTownFromList(allPrmCityTownData));

          //for show tour category
          that.parseTourCategoryData(allPrmCityTownData);

          //for show tour package
          that.parseTourPackageData(allPrmCityTownData);

        } else {
          store.dispatch(updateAllCityTownFromList([]));
          //for show tour category
          that.parseTourCategoryData([]);
          //for show tour package
          that.parseTourPackageData([]);
        }

        that.setState({ showLoader: false });

      })
      .catch(function (error) {
        console.log(error);
        that.setState({ showLoader: false });
      });
    //}
  }

  //for parse tour category data
  parseTourCategoryData = (allPrmCityTownData) => {

    let that = this;

    const uniqueTourTypes = allPrmCityTownData.filter((item, index, array) =>
      array.findIndex(obj => obj.tourType === item.tourType) === index
    );

    let tourCategoryList = [];

    tourCategoryList.push({ Name: "Select All", Key: '', ID: 0 });

    uniqueTourTypes && Object.entries(uniqueTourTypes).forEach(([index, tourTypeObj]) => {
      if (tourTypeObj.tourType) {
        tourCategoryList.push({ Name: tourTypeObj.tourType, Key: tourTypeObj.tourType, ID: tourTypeObj.tourType });
      }
    });

    //for update categry name
    const { tourCategoryId,cityTownId,newCityTownId } = that.state;

    let tourCategoryName = '';

    if (tourCategoryId == 0) {
      tourCategoryName = 'Select All';
    } else {

      const tourCategoryObj = Object.values(allPrmCityTownData).find(el => {
        return String(el.tourType).toLowerCase().trim() === String(tourCategoryId).toLowerCase().trim()
      });

      if (tourCategoryObj != undefined) {
        tourCategoryName = tourCategoryObj?.tourType || '';
      }

      //if on srp page from city changed
      if(tourCategoryName=="" && cityTownId!=newCityTownId){
        tourCategoryName = 'Select All';
      }

    }

    that.setState({ tourCategoryList, tourCategoryName });

    store.dispatch(updateTourCategoryName(tourCategoryName));

  };

  //for parse tour package data
  parseTourPackageData = (allPrmCityTownData) => {

    let that = this;
    let tourPackageList = [];

    const {tourPackageId, tourCategoryId, cityTownId, newCityTownId } = that.state;

    tourPackageList.push({ Name: "Select All", Key: '', ID: 0,DaysOfOperation:'All'});

    if(tourCategoryId == 0){
        var filteredData = allPrmCityTownData;
    }else{
        var filteredData = allPrmCityTownData.filter(item => item.tourType === tourCategoryId);

        if(filteredData && filteredData.length == 0 && cityTownId != newCityTownId){
            filteredData = allPrmCityTownData;
        }
    }

    filteredData && Object.entries(filteredData).forEach(([index, tourPkjObj]) => {

      const daysOfOp = getDaysOfOperation(tourPkjObj.DaysOfOperation);
      const name = `${tourPkjObj.CTDescription}(${daysOfOp})`;

      tourPackageList.push({
        Name:name,
        Key:name,
        ID: tourPkjObj.TripRouteIDMain,
        DaysOfOperation:daysOfOp,
      });

    });

    let tourPackageName = '';
    if (tourPackageId == 0) {
      tourPackageName = 'Select All';
    } else {
      const tourPackageObj = Object.values(allPrmCityTownData).find(el => el.TripRouteIDMain == tourPackageId);

      if (tourPackageObj != undefined) {
        tourPackageName = tourPackageObj.CTDescription + "(" + getDaysOfOperation(tourPackageObj.DaysOfOperation) + ")"
      }

      if(tourPackageName == '' && cityTownId != newCityTownId){
        tourPackageName = 'Select All';
      }

    }

    that.setState({ tourPackageList, tourPackageName });

    store.dispatch(updateTourPackageName(tourPackageName));

    //this.setAllowDayOfOperation(tourPackageName);

    this.getPackageAvailableTripDates(tourPackageId,true);

  }

  getFormattedDateForURL = (dateString) => {
    //dateString = dateString.replace(/-/g, ' '); //firefox doesn't understand hyphens in date
    const d = dateString;
    let day = d.getDate(),
      month = d.getMonth() + 1,
      year = d.getFullYear();

    if (day < 10) day = "0" + day;
    if (month < 10) month = "0" + month;

    return day + "-" + month + "-" + year;
  };

  setFromCity = (cityTownName, cityTownID, param, type = '') => {
    this.setState({ cityTownName,newCityTownId:cityTownID,daysAllowed:defaultDaysAllowed });

    console.log("from city change");

    console.log(cityTownName,cityTownID, param, type);

    if (type === 'selCity') {
      this.getTourCategoryPackage(cityTownID,true);
    }

  };

  setTourCategory = (tourCategoryName, param, type = '') => {

    let tourPackageList = [];
    let tourPackageName = "";

    const allPrmCityTownData = this.props.search.allPrmCityTownIDFromData;

    if (param != 0) {

      //filtered data by tour type, for load package tour drop donw list
      var filteredData = allPrmCityTownData.filter(item => item.tourType === tourCategoryName);

      if(filteredData){

        tourPackageList.push({ Name: "Select All", Key: '', ID: 0 ,DaysOfOperation:'All'});

        Object.entries(filteredData).forEach(([index, tourPkjObj]) => {

          const daysOfOp = getDaysOfOperation(tourPkjObj.DaysOfOperation);
          const name = `${tourPkjObj.CTDescription}(${daysOfOp})`;

          tourPackageList.push({
            Name: name,
            Key: name,
            ID: tourPkjObj.TripRouteIDMain,
            DaysOfOperation:daysOfOp,
          });
        });

      }
    }

    //for select all data
    if (param == 0) {

      tourPackageList.push({ Name: "Select All", Key: '', ID: 0 ,DaysOfOperation:'All'});

      allPrmCityTownData && Object.entries(allPrmCityTownData).forEach(([index, tourPkjObj]) => {

        const daysOfOp = getDaysOfOperation(tourPkjObj.DaysOfOperation);
        const name = `${tourPkjObj.CTDescription}(${daysOfOp})`;

        tourPackageList.push({
          Name:name,
          Key:name,
          ID: tourPkjObj.TripRouteIDMain,
          DaysOfOperation:daysOfOp,
        });
      });

      tourPackageName = "Select All";

    }

    this.setState({ tourCategoryName, tourPackageList, tourPackageName,daysAllowed:defaultDaysAllowed });

  };

  setTourPackage = (tourPackageName,TripRouteIDMain, param, type = '') => {

    console.log("tour package changed");
    console.log("TripRouteIDMain->",TripRouteIDMain);

    this.setState({ tourPackageName,daysAllowed:defaultDaysAllowed });
    //this.setAllowDayOfOperation(tourPackageName);

    if (type === 'selCity') {
      this.getPackageAvailableTripDates(TripRouteIDMain,true);
    }

  };

  getPackageAvailableTripDates = (TripRouteID,showLoader=false) => {

    if(TripRouteID!=0){

      const that = this;
      
      if(showLoader){
        that.setState({ showLoader: true });
      }

      const url = `${window.url + apiUrl.packageAvailableTripDates}?TripRouteID=${TripRouteID}`;

      fetchGet(url)
        .then(function (availableDateResponse) {

          const availDatesRes = JSON.parse(availableDateResponse);
          const pkgAllowDates = [];

          if (availDatesRes?.Success) {

            const pkgDates = availDatesRes?.data;

            if(pkgDates && Object.keys(pkgDates).length > 0){   
                if(pkgDates && Object.keys(pkgDates).length > 0){
                    pkgDates.forEach(item => {
                        const tmpDt = item.Date.split('-').reverse().join('-');
                        pkgAllowDates.push(tmpDt);
                    });
                } 
            }

          } 

          that.setState({ showLoader: false,daysAllowed:pkgAllowDates });

          console.log("pkgAllowDates ->",pkgAllowDates);

        })
        .catch(function (error) {
          console.log(error);
          that.setState({ showLoader: false });
        });
    }
  }

/*   setAllowDayOfOperation = (tourPackageName) => {

    const tpList = this.state.tourPackageList;
    const result = tpList.find(item => item.Name === tourPackageName);

    var allowWeekDays = defaultDaysAllowed;
    
    if(tourPackageName && result && result.DaysOfOperation!="" && result.DaysOfOperation!="Any" && result.DaysOfOperation!="All"){
    
       const daysOfOperation = result.DaysOfOperation;

       var daysOfOperationArray  = daysOfOperation.split(",");

        allowWeekDays = [];

        daysOfOperationArray.forEach(el => {
            var weekDayIndex = getWeekDayIndex(el);
            if(weekDayIndex !== -1){
                allowWeekDays.push(weekDayIndex);
            }
        })
    }

    this.setState({daysAllowed:allowWeekDays});
  } */

  checkOutsideRange = (param, e) => {
    //console.log("hello");
    let today = new Date(window.today);
    today.setHours(0, 0, 0, 0);
    let ninety = new Date(window.today);
    ninety = ninety.setDate(ninety.getDate() + window.daysForCalendar);

    const daysAllowed = this.state.daysAllowed;
    if (param === "dep") {

      if(daysAllowed=="reset"){
        return !(today <= e._d && ninety > e._d);
      }else{
          const daysAllowed = this.state.daysAllowed;
          const allowedMomentDates = daysAllowed.map(d => moment(d, "YYYY-MM-DD"));
          return !allowedMomentDates.some(allowedDay => e.isSame(allowedDay, 'day'));
      }
    }/*  else {
      if (this.state.depDate && this.state.depDate._d) {
        const depDate = this.state.depDate._d;
        return !(depDate <= e._d && ninety > e._d);
      } else {
        return !(today <= e._d && ninety > e._d);
      }
    } */
  };

/*   isDayBlocked = (day) => {
    // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
    const daysAllowed = this.state.daysAllowed;
    const dayOfWeek = day.day(); 
    return !daysAllowed.includes(dayOfWeek);
  }; */

  modifySrch = () => {

    const frCityName = this.state.cityTownName;
    const categoryName = this.state.tourCategoryName;
    const packageName = this.state.tourPackageName;
    const departDate = this.state.depDate ? this.state.depDate._d : false;

    const depD = getDateForSrch(departDate);
    ////////////
    const fromCityObj = Object.values(this.state.cityTownFromList).find((el) => {
      return el.Name === frCityName;
    });

    let cityTownId = 0;
    if (fromCityObj != undefined) {
      cityTownId = fromCityObj.ID;
    }

    /////////////
    const tourCategoryObj = Object.values(this.state.tourCategoryList).find((el) => {
      return el.Name === categoryName;
    });

    let tourCategoryId = 0;
    if (tourCategoryObj != undefined) {
      tourCategoryId = tourCategoryObj.ID;
    }

    /////////////
    const tourPackageObj = Object.values(this.state.tourPackageList).find((el) => {
      return el.Name === packageName;
    });

    let tourPackageId = 0;
    if (tourPackageObj != undefined) {
      tourPackageId = tourPackageObj.ID;
    }

    /* console.log(frCityName);
    console.log(cityTownId);

    console.log(categoryName);
    console.log(tourCategoryId);

    console.log(packageName);
    console.log(tourPackageId);

    console.log(departDate);
    console.log(depD); */

    let url = '';
    if (!frCityName || !departDate) {

      let fromErr = !frCityName ? true : false;
      let depErr = !departDate ? true : false;
      this.setState({ fromErr, depErr });
      return;

    } else {

      const variantCode = this.props.search.searchParams.variantCode;

      url = "/search_tour_package?fromCity=" + cityTownId +
        "&tourCategory=" + tourCategoryId +
        "&tripRoute=" + tourPackageId +
        "&variantCode=" + variantCode +
        "&jDate=" + depD;

      window.location.href = url;
    }
  };

  showaertdialogue = () => {
    setTimeout(() => {
      this.setState({ alerterror: "" });
    }, 5000);
    return (
      <div
        className="blacklayer"
        onClick={() => {
          this.setState({ alerterror: "" });
        }}
      >
        <div className="popupbox">
          <div className="alertmsg">{this.state.alerterror}</div>
          <button
            className="alertbuttonok crsrpointer"
            onClick={() => {
              this.setState({ alerterror: "" });
            }}
          >
            OK{" "}
          </button>
        </div>
      </div>
    );
  };

  render() {

    let that = this;

    return (
      <section className="searchformsection">
        {that.state.alerterror !== "" ? that.showaertdialogue() : ""}
        {that.state.showLoader && (
          <div className="show-load">
              <div className="loading">
                  <span></span>
                  <span></span>
                  <span></span>
              </div>
          </div>
        )}
        <div className="searchbar">
          <Auto
            className="Fromcity cityinput"
            list={this.state.cityTownFromList}
            placeholder="Select From City"
            value={this.state.cityTownName}
            setValue={this.setFromCity}
            err={this.state.fromErr}
            label="From City"
            inputpadding="34px 15px 17px 23px"
            spanclassname="mod-clear flex-vc"
          />
          <Auto
            className="TourCategory cityinput"
            list={this.state.tourCategoryList}
            placeholder="Select Tour Category"
            value={this.state.tourCategoryName}
            setValue={this.setTourCategory}
            err={this.state.toErr}
            label="Tour Category"
            inputpadding="30px 15px 10px 25px"
            spanclassname="mod-clear flex-vc"
          />
          <Auto
            className="PackageTour cityinput"
            list={this.state.tourPackageList}
            placeholder="Select Package Tour"
            value={this.state.tourPackageName}
            setValue={this.setTourPackage}
            err={this.state.toErr}
            label="Package Tour"
            inputpadding="30px 15px 10px 25px"
            spanclassname="mod-clear flex-vc"
          />
          <div
            className={
              this.state.depErr ? "mo-inp err cityinput" : "mo-inp cityinput"
            }
          >
            <SingleDatePicker
              id="onwardjdate"
              readOnly={true}
              date={this.state.depDate} // momentPropTypes.momentObj or null
              onDateChange={(depDate) =>
                this.setState({ depDate })
              } // PropTypes.func.isRequired
              focused={this.state.focused} // PropTypes.bool
              onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
              hideKeyboardShortcutsPanel={true}
              block={true}
              numberOfMonths={2}
              noBorder={true}
              displayFormat="ddd MMM  DD YYYY"
              placeholder="Choose date"
              isOutsideRange={(event) => this.checkOutsideRange("dep", event)}
              anchorDirection="left"
              firstDayOfWeek={0}
            />
            <span className="mod-clear calendar">
              {renderImg('CalendarIconGray')}
            </span>
            <label>{t(JOURNEY_DATE)}</label>
          </div>
          <div className="modifybutton" onClick={this.modifySrch}>
            {t(MODIFY)}
          </div>
        </div>
        <div className="darklayer"></div>
      </section>
    );
  }
}

const mapStateToProps = function (store) {
  return store;
};

export default connect(mapStateToProps)(Modify);